export const RRS_REPAYMENT_PERIOD = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Nedbetalingstid – jo kortere, desto bedre',
  url: 'https://scoopr.no/nedbetalingstid',
  description:
    'Nedbetalingstiden er enkelt forklart den tiden det tar deg å betale tilbake et lån. Men hva skjer med lånet dersom du har mulighet til å betale ned raskere? Vi kan røpe såpass at om du velger kortere nedbetalingstid kan du spare MYE penger.',
  datePublished: '2022-01-13T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
